import { pushEvent } from '@nykaa/data-layer';
import { CartData } from 'store/addToCart/types';
import { PrimaryCategories, Product } from 'store/product/types';
import { Variant } from '@nykaa/variant-selector-shared/types';
import { PageSource } from 'shared/constants/dataLayer';
import { isSize } from './helpers';

export const VIEW_DETAILS_CTA_CLICKED = 'view_details_cta_clicked';
export const ADD_TO_CART_EVENT = 'add_to_cart_plp';
export const STEPPER_QUANTITY_UPDATE = 'stepper_quantity_update';

const getCategoryLevelName = (primaryCategoryDTOList: PrimaryCategories) => ({
  l1: primaryCategoryDTOList ? primaryCategoryDTOList.l1.name : '',
  l2: primaryCategoryDTOList ? primaryCategoryDTOList.l2?.name ?? '' : '',
  l3: primaryCategoryDTOList ? primaryCategoryDTOList.l3?.name ?? '' : '',
});

export const getVariantPageInfo = (variantType?: string) => {
  const variantPage = isSize(variantType)
    ? PageSource.SIZE_PAGE
    : PageSource.SHADE_PAGE;
  return { variantPage };
};

export const getViewDetailsQueryParam = (variantType?: string) => {
  const variantPage = isSize(variantType)
    ? PageSource.SIZE_PAGE
    : PageSource.SHADE_PAGE;
  return `variantSource=${encodeURIComponent(`${variantPage}:viewdetails`)}`;
};

// export const fireTrackingForViewDetailsCTA = (product: Product) => {
//   const eventData = {
//     interactionLocation: 'categoryListingPage:selectSize_bottomsheet',
//     categoryL1Name: getCategoryLevelName(product.primaryCategories).l1,
//     categoryL2Name: getCategoryLevelName(product.primaryCategories).l2,
//     categoryL3Name: getCategoryLevelName(product.primaryCategories).l3,
//     brandName: product.brandName,
//     discountedPercent: product.discount,
//     discountedPrice: product.price,
//     mrpPrice: product.mrp,
//     productId: product.id,
//     productName: product.name,
//     variantProductId: product.childId,
//     variantType: product.variantType,
//     products: [
//       {
//         interactionLocation: 'categoryListingPage:selectSize_bottomsheet',
//         categoryL1Name: getCategoryLevelName(product.primaryCategories).l1,
//         categoryL2Name: getCategoryLevelName(product.primaryCategories).l2,
//         categoryL3Name: getCategoryLevelName(product.primaryCategories).l3,
//         brandName: product.brandName,
//         discountedPercent: product.discount,
//         discountedPrice: product.price,
//         mrpPrice: product.mrp,
//         productId: product.id,
//         productName: product.name,
//         variantProductId: product.childId,
//         variantType: product.variantType,
//       },
//     ],
//   };
//   pushEvent(VIEW_DETAILS_CTA_CLICKED, {
//     productClickData: eventData,
//   });
// };

interface StepperTrackingParams {
  product: Product;
  variants: Variant[];
  childId: string;
  originalQuantity: number;
  updatedQuantity: number;
  userAction: 'increase' | 'decrease';
}

export const fireStepperQuantityUpdateTracking = ({
  product,
  variants,
  childId,
  originalQuantity,
  updatedQuantity,
  userAction,
}: StepperTrackingParams) => {
  const variant = variants.find((v) => v.childId === childId);
  const { variantPage } = getVariantPageInfo(product.variantType);

  pushEvent(STEPPER_QUANTITY_UPDATE, {
    stepperQuantityUpdate: {
      productId: product.parentId,
      variantType: product.variantType,
      variantProductId: childId,
      productType: product.productType,
      productName: product.name,
      brandName: product.brandName,
      categoryL1Name: getCategoryLevelName(product.primaryCategories).l1,
      categoryL2Name: getCategoryLevelName(product.primaryCategories).l2,
      categoryL3Name: getCategoryLevelName(product.primaryCategories).l3,
      originalQuantity,
      updatedQuantity,
      currency: 'INR',
      mrpPrice: variant?.mrp,
      discountedPrice: variant?.offerPrice,
      discountedPercent: variant?.discount,
      variantPage: variantPage,
      userAction,
    },
  });
};

export const fireAddToCartEvent = (product: Product, cartData: CartData) => {
  const { variantPage } = getVariantPageInfo(product.variantType);

  const productExtraData = {
    productId: product.parentId,
    categoryL1Name: getCategoryLevelName(product.primaryCategories).l1,
    categoryL2Name: getCategoryLevelName(product.primaryCategories).l2,
    categoryL3Name: getCategoryLevelName(product.primaryCategories).l3,
    variantType: product.variantType,
    brandName: product.brandName,
    variantPage: variantPage,
    currency: 'INR',
    productType: product.productType,
  };
  if (cartData && cartData.items && cartData.items.length > 0) {
    cartData.items.forEach((item) => {
      const itemObj = {
        variantProductId: item.productId,
        productName: item.name,
        mrpPrice: item.mrp,
        discountedPrice: item.offerPrice,
        discountedPercent: item.discount,
      };
      pushEvent(ADD_TO_CART_EVENT, {
        addToCartData: {
          ...productExtraData,
          ...itemObj,
        },
      });
    });
  }
};
